import "../Styles/Pages/Auth.css";
import Login from "../Components/Auth/Login";
import Signup from "../Components/Auth/Signup";
import ForgotPassword from "../Components/Auth/ForgotPassword";
import ResetPassword from "../Components/Auth/ResetPassword";
import { useParams } from "react-router-dom";

const Auth = () => {
  const { type } = useParams();

  const renderAuthComponent = () => {
    switch (type) {
      case "login":
        return <Login />;
      case "signup":
        return <Signup />;
      case "forgotPassword":
        return <ForgotPassword />;
      case "resetPassword":
        return <ResetPassword />;
      default:
        return <Login />;
    }
  };

  return <div className="auth">{renderAuthComponent()}</div>;
};

export default Auth;
